import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { toJS } from 'mobx';
import DataTable from '../../..//DataTable';
import Spinner from "../../../Spinner";

@inject("surveyTopicStore")
@observer
class SurveyTopicList extends Component {
  static propTypes = {
    params: PropTypes.shape().isRequired,
    route: PropTypes.shape().isRequired,
    children: PropTypes.node,
  }

  componentWillMount() {
    const { surveyTopicStore } = this.props;
    surveyTopicStore.fetchItems();
    if (!surveyTopicStore.types.length) surveyTopicStore.fetchTypes();
  }

  handleDelete = (idOrIds) => {
    this.props.surveyTopicStore.removeItems(idOrIds);
  }

  slug = 'monitoring/survey/topic';
  columns = [
    { key: 'id', label: 'ID' },
    { key: 'name', label: 'Name' },
    { key: 'caption', label: 'Caption' },
    { key: 'description', label: 'Description' },
    { key: 'type.name', label: 'Type' },
  ];

  render() {
    const { surveyTopicStore, children } = this.props;

    let data = surveyTopicStore.items.map(item => ({
      id: item.id,
      name: item.name,
      caption: item.caption,
      description: item.description,
      type: surveyTopicStore.findTypeById(item.type)
    }))

    return (
      <div>
        <DataTable
          data={data}
          slug={this.slug}
          columns={this.columns}
          onDelete={this.handleDelete}
          allowAdd
          allowEdit
          allowDelete
          resource='maintenance'
        />
        {surveyTopicStore.isLoading && <Spinner />}
        {!surveyTopicStore.isLoading && children}
      </div>
    );
  }
}

export default SurveyTopicList;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Survey/Topic/SurveyTopicList.js